export enum SubcontractorDecisionStatus {
  ALL = 'ALL',
  MISSED = 'MISSED',
  VALID = 'VALID',
  EXPIRED = 'EXPIRED',
}
